<template>
  <div class="mb-3 card">
    <div class="card-header bg-secondary-3">
      <div
        v-if="value.area.letter"
        class="rounded letter-box mr-2 d-inline-flex align-items-center justify-content-center"
        :style="{
          color: value.area.letterColor || 'white',
          backgroundColor: `${value.area.letterColor}14` || '#2db78226',
          borderColor: value.area.letterColor || '#2db782',
        }"
      >
        {{ value.area.letter | empty }}
      </div>
      <span v-if="titlePrefix" class="mr-2 ">{{ titlePrefix }}</span>
      <b>
        {{ value.area.name | empty }}
        <span v-if="value.area.description">:</span>
      </b>
      <span v-if="value.area.description">
        {{ value.area.description | empty }}
      </span>
    </div>
    <div class="card-body bg-secondary-3">
      <div class="row">
        <div class="col-12" :class="{ 'col-md': !isHalf }">
          <label class="data-name">{{ requiredLevelLabel }}</label>
          <div class="row d-flex align-items-center">
            <div
              class="col-12"
              :class="{
                'col-md-3': hasBoolValue(model.requiredLevel?.hasOther),
              }"
            >
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio
                  v-if="isYesNoOption"
                  v-model="requiredLevel"
                  class="row"
                  custom-error-msg="El campo es requerido."
                  :disabled="isReadOnly"
                  :error="!!errors[0]"
                  is-inline
                  :name="`requiredLevel-${value.area.id}`"
                  :options="options"
                />
                <custom-drop-down
                  v-else
                  v-model="requiredLevel"
                  :clearable="!isReadOnly"
                  custom-error-msg="El campo es requerido."
                  :disabled="isReadOnly"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="options"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div v-if="hasBoolValue(model.requiredLevel?.hasOther)" class="col">
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-if="model.requiredLevel.hasOther && !isReadOnly"
                  v-model="model.requiredLevel.other"
                  custom-error-msg="El campo es requerido."
                  :error="errors[0]"
                  type="text"
                />
                <input
                  v-else
                  class="form-control"
                  disabled
                  :value="value.requiredLevel.other"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div v-if="isHalf" class="col-12"><div class="border-top my-4" /></div>
        <div class="col-12" :class="{ 'col-md': !isHalf }">
          <label class="data-name">{{ evaluatedLevelLabel }}</label>
          <div class="row d-flex align-items-center">
            <div
              class="col-12"
              :class="{
                'col-md-3': hasBoolValue(model.evaluatedLevel?.hasOther),
              }"
            >
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio
                  v-if="isYesNoOption"
                  v-model="evaluatedLevel"
                  class="row"
                  custom-error-msg="El campo es requerido."
                  :disabled="isReadOnly"
                  :error="!!errors[0]"
                  is-inline
                  :name="`evaluatedLevel-${value.area.id}`"
                  :options="options"
                />
                <custom-drop-down
                  v-else
                  v-model="evaluatedLevel"
                  :clearable="!isReadOnly"
                  custom-error-msg="El campo es requerido."
                  :disabled="isReadOnly"
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="options"
                  placeholder="Seleccione"
                />
              </validation-provider>
            </div>
            <div
              v-if="hasBoolValue(model.evaluatedLevel?.hasOther)"
              class="col"
            >
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-input
                  v-if="model.evaluatedLevel.hasOther && !isReadOnly"
                  v-model="model.evaluatedLevel.other"
                  custom-error-msg="El campo es requerido."
                  :error="errors[0]"
                  type="text"
                />
                <input
                  v-else
                  class="form-control"
                  disabled
                  :value="value.evaluatedLevel.other"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div v-if="isHalf" class="col-12"><div class="border-top my-4" /></div>
        <div
          class="col-12 d-flex align-items-center"
          :class="{ 'col-md': !isHalf }"
        >
          <div :class="{ 'mt-4': !isHalf }">
            <div class="d-flex align-items-center">
              <div
                v-for="item in stateOptions"
                :key="item.id"
                class="mt-1 mr-4"
              >
                <check-box
                  :disabled="isReadOnly"
                  :text="item.name"
                  :value="checkeds.includes(item.id)"
                  @input="onCheck($event, item)"
                />
              </div>
            </div>
            <div class="d-block mt-2">
              <validation-provider
                :ref="`${value.area.id}-checkeds`"
                v-slot="{ errors }"
                :name="`${value.area.id}-checkeds`"
                :rules="checkeds?.length ? '' : 'required'"
              >
                <error
                  v-if="errors[0]"
                  message="Debe seleccionar al menos una opción."
                  variant="no-border"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </div>
      <div class="border-top my-4" />
      <div class="d-flex justify-content-between align-items-center">
        <validation-provider
          v-slot="{ errors }"
          class="w-100"
          :name="`area-${value.area.id}-answer`"
          rules="required"
        >
          <input v-model="model.answer" type="hidden" />

          <div class="d-flex justify-content-between">
            <button
              v-for="option in answerOptions"
              :key="`option-answer-${option.id}`"
              class="ged-answer-btn"
              :class="{ active: isAnswerSelected(option) }"
              :disabled="isReadOnly"
              type="button"
              @click="onAnswer(option)"
            >
              <i
                class="far d-block mb-1"
                :class="[
                  isAnswerSelected(option) ? 'fa-check-circle' : 'fa-circle',
                ]"
              />
              {{ option.name }}
            </button>
          </div>

          <error
            v-if="errors[0]"
            message="Debe seleccionar al menos una opción."
            variant="no-border mt-2"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CheckBox from 'CheckBox';
import CustomRadio from 'custom-radio';
import Error from 'custom-error';
import CustomInput from 'CustomInput';

import Categories from '@/utils/constants/vocationalEvaluationInstrumentAreaCategory.js';

export default {
  name: 'EvaluatedAreaAnswer',
  components: {
    ValidationProvider,
    CustomDropDown,
    CheckBox,
    CustomRadio,
    Error,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    stateOptions: {
      type: Array,
      default: () => [],
    },
    answerOptions: {
      type: Array,
      default: () => [],
    },
    yesNoOptions: {
      type: Array,
      default: () => [],
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isHalf: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    requiredLevel: {
      get() {
        return this.options.find((x) => x.id === this.model.requiredLevel?.id);
      },
      set(option) {
        this.model.requiredLevel = { ...option };
      },
    },
    evaluatedLevel: {
      get() {
        return this.options.find((x) => x.id === this.model.evaluatedLevel?.id);
      },
      set(option) {
        this.model.evaluatedLevel = { ...option };
      },
    },
    requiredLevelLabel() {
      switch (this.value.area?.category) {
        case Categories.WorkerFunctions:
          return 'Nivel Requerido de la Profesión:';
        case Categories.Temperaments:
          return '¿Este temperamento es requerido para la profesión?';
        case Categories.EnvironmentalWorkConditions:
          return '¿Esta condición de trabajo es requerida para la profesión?';
        case Categories.PhysicalDemandsForce:
          return '¿Esta demanda física es requerida para la profesión?';
        case Categories.PhysicalDemandsPhysicalMovements:
          return 'Nivel Requerido de la Profesión:';
        default:
          return '';
      }
    },
    evaluatedLevelLabel() {
      switch (this.value.area?.category) {
        case Categories.WorkerFunctions:
          return 'Perfil del Evaluado:';
        case Categories.Temperaments:
          return '¿El perfil del evaluado cumple con este temperamento?';
        case Categories.EnvironmentalWorkConditions:
          return '¿El perfil del evaluado cumple con la condición de trabajo?';
        case Categories.PhysicalDemandsForce:
          return '¿El perfil del evaluado cumple con la demanda física?';
        case Categories.PhysicalDemandsPhysicalMovements:
          return 'Perfil del Evaluado:';
        default:
          return '';
      }
    },
    checkeds() {
      return this.model.states ?? [];
    },
    options() {
      let options = [];
      if (this.value.area.options?.length) options = this.value.area.options;
      else if (this.isYesNoOption) options = this.yesNoOptions;
      return options.map((x) => ({
        ...x,
        value: x.id,
        label: x.name,
      }));
    },
    titlePrefix() {
      switch (this.value.area?.category) {
        case Categories.WorkerFunctions:
          return 'Función de Trabajo:';
        case Categories.Temperaments:
          return 'Temperamento:';
        case Categories.EnvironmentalWorkConditions:
          return 'Condición Ambiental del Trabajo:';
        case Categories.PhysicalDemandsForce:
          return 'Fuerza:';
        case Categories.PhysicalDemandsPhysicalMovements:
          return 'Movimientos Físicos:';
        default:
          return '';
      }
    },
    isYesNoOption() {
      const categories = [
        Categories.Temperaments,
        Categories.EnvironmentalWorkConditions,
        Categories.PhysicalDemandsForce,
      ];
      return categories.includes(this.value.area?.category);
    },
    hasBoolValue() {
      return (val) => [true, false].includes(val);
    },
    isAnswerSelected() {
      return (x) => this.model.answer?.id === x.id;
    },
  },
  methods: {
    onCheck(val, item) {
      if (val) {
        if (!this.model.states.includes(item.id))
          this.model.states.push(item.id);
      } else {
        const index = this.model.states.findIndex((x) => x === item.id);
        if (index !== -1) this.model.states.splice(index, 1);
      }
      if (this.stateOptions.length) {
        this.$refs[`${this.value.area.id}-checkeds`].setErrors({});
      }
    },
    onAnswer(item) {
      this.model.answer = item;
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.letter-box {
  width: 30px;
  height: 30px;
  line-height: 30px;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  border: 1px solid;
}
::v-deep .custom-radio__extended {
  .custom-radio-container {
    display: flex;
    -webkit-box-pack: justify !important;
    -ms-flex-pack: justify !important;
    justify-content: space-between !important;
    .radio-button {
      border: unset;
      background: map-get($colors, 'secondary-9') !important;
      width: 33% !important;
      flex-shrink: 0 !important;
      .radio {
        margin-top: 10px;
      }
      .step-label {
        font-size: 12px;
        color: map-get($colors, 'gray-8');
      }
    }
    .radio-button.bg-checked {
      background: map-get($colors, 'secondary-22') !important;
      .step-label {
        color: map-get($colors, 'white') !important;
      }
      .rounded-circle {
        border-color: map-get($colors, 'white');
        i {
          color: map-get($colors, 'white');
          top: -5px;
        }
      }
    }
  }
}

.ged-answer-wrapper {
  border-left: 1px solid #e1e1e1;
  padding-left: 1rem;
}

@media (max-width: 991.98px) {
  .ged-answer-wrapper {
    border-left: none;
    border-top: 1px solid #e1e1e1;
    padding-left: 0;
    padding-top: 1rem;
    justify-content: flex-start !important;
    flex-wrap: wrap;
  }

  .ged-answer-btn {
    margin-left: 0;
    margin-right: 0.45rem;
    margin-bottom: 0.45rem;
  }
}

.ged-answer-btn {
  min-width: 32.5%;
  border: 1px solid #f2f2f2;
  background: #f2f2f2;
  color: #a8b7b5;
  padding: 0.65rem 0.75rem;
  border-radius: 6px;
  font-size: 12px;
}

.ged-answer-btn i {
  font-size: 16px;
  color: #9bb0ad;
}

.ged-answer-btn.active {
  background: #2db782;
  border-color: #2db782;
  color: #fff;
}

.ged-answer-btn.active i {
  color: #fff;
}

.ged-answer-btn:disabled.active {
  background: #3f5b60;
  border-color: #3f5b60;
  color: #fff;
}

.ged-answer-btn:disabled:not(.active) {
  background: #f4f4f4;
  border-color: #f4f4f4;
  color: #aeb8b6;
  opacity: 1;
}

.ged-answer-btn:disabled:not(.active) i {
  color: #9bb0ad;
}

.ged-answer-btn:disabled {
  cursor: not-allowed;
}

::v-deep .input-group .option-input:disabled:checked + label span {
  background-color: #3f5b60 !important;
}
::v-deep .input-group .option-input:disabled:checked + label span .ic-check {
  background-image: url('../../../../../../assets/img/white-check.svg') !important;
  background-size: 70% !important;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
